// test1118
(1118 && 0);
